import { render, staticRenderFns } from "./news-loader.vue?vue&type=template&id=548f1364&"
import script from "./news-loader.vue?vue&type=script&lang=js&"
export * from "./news-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('548f1364', component.options)
    } else {
      api.reload('548f1364', component.options)
    }
    module.hot.accept("./news-loader.vue?vue&type=template&id=548f1364&", function () {
      api.rerender('548f1364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-loader.vue"
export default component.exports